var $ = require("jquery");
require("../modules/front/form_parameters");
require("../modules/front/make_city_list");
require("slick-carousel");
import "../stylesheets/slick";

//検索結果一覧js
$(function () {
  const spMax = 640;

  const slickSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    variableWidth: false,
    centerMode: false,
    prevArrow:
      '<button type="button" class="result-action-list-front__arrow result-action-list-front__arrow--prev">前へ</button>',
    nextArrow:
      '<button type="button" class="result-action-list-front__arrow result-action-list-front__arrow--next">次へ</button>',
    variableWidth: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerMode: false
        }
      }
    ],
    initialSlide: 0
  };

  //==========
  //リストに追加された事務所スライダー
  //==========
  var slider = $(".js-list-slider-front");
  slider.slick(slickSettings);

  // スライダーの親要素のdisplay:noneにより表示崩れを直す処理
  $(".result-action-front__confirm .js-toggle-trigger").click(function () {
    slider.slick("setPosition");
  });

  //==========
  //sp用js
  //==========
  if ($(window).width() <= spMax) {
    // 条件を変更する画面表示
    $(".js-conditions-trigger").on("click", function (e) {
      e.preventDefault();

      var condition = $($(this).attr("href"));

      condition.addClass("is-open");
    });

    $(".js-conditions-close").on("click", function (e) {
      e.preventDefault();

      var condition = $($(this).attr("href"));

      condition.removeClass("is-open");
    });
  }

  //========
  //条件をクリア 先頭で$宣言しているため挙動変化に注意
  //========
  $(".js--clear").on("click", function () {
    $(".js-prefecture-select").prop("selectedIndex", 0);
    $(".js-city-select").val("");
    $(".js-city-select").prop("disabled", true);
    $(".js-administrative_district-select").val("");
    $(".js-administrative_district-select").prop("disabled", true);
    $(".js-prefecture-area-select").prop("selectedIndex", 0);
    $(".js-keyword").prop("value", "");
    $("input[type=checkbox]").prop("checked", false);
  });

  //========
  //表示件数変更
  //========
  $(".js-page_count").on("change", function () {
    var pageCount = $(".js-page_count").val();
    location.href = getOfficesUrl(pageCount);
  });

  //========
  //まとめてお問い合わせに追加/削除
  //========
  $(".js-inquiry-list").on("click", function () {
    var target = $(this);
    var branchId = target.data("branch");

    function changeResultClass(_target) {
      // リストに追加・削除のcss反転
      _target.toggleClass("js-add-list");
      _target.toggleClass("js-remove-list");
    }

    function initListCountAndButton(count) {
      $(".result-action-front__number").text(count + "件");
      $(".button-primary-front__count").text(count);
    }

    //========
    //登録済みの拠点一覧を元にリストの追加削除ボタンの整合性をチェックする
    //========
    function checkAddlistButton(branches) {
      $(".js-remove-list").each(function (index, button) {
        if (!branches.includes($(button).attr("data-branch"))) {
          changeResultClass($(button));
          $(button).text("検討リストに追加");
        }
      });
      $(".js-add-list").each(function (index, button) {
        if (branches.includes($(button).attr("data-branch"))) {
          changeResultClass($(button));
          $(button).text("検討リストから削除");
        }
      });
    }

    if (target.hasClass("js-add-list")) {
      // リストに追加
      $.getJSON("/offices/inquiry_offices?command=add&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        // リスト内会計事務所登録
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initListCountAndButton(json.count);
        if (json.result == "NG") {
          alert("一度にお問い合わせ可能な税理士・会計事務所は5件までです。");
          // 既に登録済みの拠点を登録しようとした時
        } else if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストに登録されています。");
        }
      });
    } else if (target.hasClass("js-remove-list")) {
      // リストから削除
      $.getJSON("/offices/inquiry_offices?command=remove&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initListCountAndButton(json.count);
        if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストから削除されています。");
        }
      });
    } else if (target.hasClass("js-remove-mini-list")) {
      // リストから削除 in まとめてお問い合わせ
      $.getJSON("/offices/inquiry_offices?command=remove&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initListCountAndButton(json.count);
        if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストから削除されています。");
        }
      });
    }
  });

  //========
  //まとめてお問い合わせから削除(リスト)
  //========
  $(".js-list-slider-front").on("click", ".js-inquiry-mini-list", function () {
    var target = $(this);
    var branchId = target.data("branch");

    function changeResultClass(_target) {
      // リストに追加・削除のcss反転
      _target.toggleClass("js-add-list");
      _target.toggleClass("js-remove-list");
    }

    function initListCountAndButton(count) {
      $(".result-action-front__number").text(count + "件");
      $(".button-primary-front__count").text(count);
    }

    //========
    //登録済みの拠点一覧を元にリストの追加削除ボタンの整合性をチェックする
    //========
    function checkAddlistButton(branches) {
      $(".js-remove-list").each(function (index, button) {
        if (!branches.includes($(button).attr("data-branch"))) {
          changeResultClass($(button));
          $(button).text("検討リストに追加");
        }
      });

      $(".js-add-list").each(function (index, button) {
        if (branches.includes($(button).attr("data-branch"))) {
          changeResultClass($(button));
          $(button).text("検討リストから削除");
        }
      });
    }

    if (target.hasClass("js-remove-mini-list")) {
      // リストから削除 in まとめてお問い合わせ
      $.getJSON("/offices/inquiry_offices?command=remove&id=" + branchId, function () {}).done(function (json) {
        // 検索結果内 会計事務所ボタン切り替え
        checkAddlistButton(json.branches);
        slider.slick("unslick");
        // 別タブで操作した場合を想定し、一覧を作成し直して同期を取る
        slider.empty();
        slider.append(json.data);
        slider.slick(slickSettings);
        initListCountAndButton(json.count);
        if (json.result == "DUP") {
          alert("選択した税理士・会計事務所は既にリストから削除されています。");
        }
      });
    }
  });

  //========
  //まとめてお問い合わせ遷移
  //========
  $(".js-inquiry-multi").on("click", function () {
    // 値を保存できないため近くの数値を取得。遷移先は_index_js.html.slimに委託
    var count = $(".button-primary-front__count").text();
    if (count > 0) {
      location.href = getInquiryUrl();
    } else {
      alert("お問い合わせリストに事務所が追加されていません");
    }
  });
});

//==========
//まとめてお問い合わせボタン 追従範囲指定処理
//==========
$(window).on("load scroll", function () {
  var footerTop = $(".footer-front").offset().top;
  var resultAction = $(".js-result-action-front");
  var resultActionBottom = resultAction.offset().top + resultAction.height();

  if (resultActionBottom > footerTop) {
    resultAction.removeClass("is-shown");
  } else {
    resultAction.addClass("is-shown");
  }
});
